<script>
  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  import LabelInfo from '../labelInfo.svelte'
  import { calledFromLabel } from '../../stores.js'
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()
  const close = () => dispatch('close')

  const handle_keydown = (e) => {
    if (e.key === 'Escape') {
      close()
      return
    }
  }

  const refs = {
    vuitton: {
      text:
        'Inspired by some French and Italian hotel labels from Gaston-Louis Vuitton’s collection, which includes more than 300 examples collected at the beginning of the 20th century.',
      link: 'https://exb.fr/fr/le-catalogue/75-escales-autour-du-monde.html',
    },
    fili: {
      text:
        'Inspired by Louise Fili’s sublime collection of Italian Signs. She has rigorously documented and organised her photos, which she has been taking all over Italy for years, obsessively.',
      link: 'https://www.louisefili.com/graficadellastrada',
    },
  }

  const fontPaths = {
    arteria: 'https://typofonderie.com/fonts/arteria-compress-family/',
    aiglon: 'https://typofonderie.com/fonts/',
  }
  const labels = [
    {
      name: 'Hotel Isotta',
      path: 'images/labels/Arteria_etiquettes_hotel-isotta.png',
      span: 1,
      fontList: [
        { name: 'Arteria Compress Demi', path: fontPaths.arteria },
        { name: 'Aiglon Regular', path: fontPaths.aiglon },
        {
          name: 'Arteria Compress Heavy',
          OT: 'Italian A',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.vuitton,
    },
    {
      name: 'Olio di Semi',
      path: 'images/labels/Arteria_fili-shop-signs-olio-semi.png',
      span: 1,
      fontList: [{ name: 'Arteria Compress Demi', path: fontPaths.arteria }],
      selected: true,
      ref: refs.fili,
    },
    {
      name: 'Capo Ufficio Veicoli',
      path: 'images/labels/Arteria_fili-shop-signs-ufficio.png',
      span: 1,
      fontList: [
        {
          name: 'Arteria Compress Regular',
          OT: 'Italian A, Closed C',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.fili,
    },
    {
      name: 'Berlin Hilton',
      path: 'images/labels/Arteria_etiquettes_hotel-berlin.png',
      span: 1,
      fontList: [
        { name: 'Arteria Compress Bold', path: fontPaths.arteria },
        { name: 'Arteria Compress Demi', path: fontPaths.arteria },
      ],
      selected: true,
      ref: refs.vuitton,
    },
    {
      name: 'Victoria Hotel',
      path: 'images/labels/Arteria_etiquettes_hotel-alicante.png',
      span: 1,
      fontList: [{ name: 'Arteria Compress Bold', path: fontPaths.arteria }],
      selected: true,
      ref: refs.vuitton,
    },
    {
      name: 'Saturnia Hotel',
      path: 'images/labels/Arteria_etiquettes_hotel-saturnia.png',
      span: 1,
      fontList: [
        { name: 'Arteria Compress Heavy', path: fontPaths.arteria },
        { name: 'Arteria Compress Demi', path: fontPaths.arteria },
        { name: 'Arteria Compress Light', path: fontPaths.arteria },
      ],
      selected: true,
      ref: refs.vuitton,
    },
    {
      name: 'Dirigente Movimento',
      path: 'images/labels/Arteria_fili-shop-signs-dirigente.png',
      span: 1,
      fontList: [{ name: 'Arteria Compress Regular', path: fontPaths.arteria }],
      selected: true,
      ref: refs.fili,
    },
    {
      name: 'Ditta Alfonso Evangelisti',
      path: 'images/labels/Arteria_fili-shop-signs-alfonso.png',
      span: 2,
      fontList: [
        { name: 'Aiglon Wide Regular', path: fontPaths.aiglon },
        {
          name: 'Arteria Compress Bold',
          OT: 'Italian A',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.fili,
    },
    {
      name: 'Macelleria con Vendita',
      path: 'images/labels/Arteria_fili-shop-signs-macelleria.png',
      span: 1,
      fontList: [
        {
          name: 'Arteria Compress Demi',
          OT: 'Closed C',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.fili,
    },
    {
      name: 'Hotel Livingstone',
      path: 'images/labels/Arteria_etiquettes_hotel-livingstone.png',
      span: 1,
      fontList: [
        { name: 'Arteria Compress ExtraBold', path: fontPaths.arteria },
        {
          name: 'Arteria Compress Regular',
          OT: 'Single-story a',
          path: fontPaths.arteria,
        },
        { name: 'Arteria Compress ExtraBold', path: fontPaths.arteria },
        { name: 'Arteria Compress Regular', path: fontPaths.arteria },
      ],
      selected: true,
      ref: refs.vuitton,
    },
    {
      name: 'Grand Hotel Univers',
      path: 'images/labels/Arteria_etiquettes_hotel-univers.png',
      span: 1,
      fontList: [
        { name: 'Aiglon Heavy', path: fontPaths.aiglon },
        { name: 'Arteria Compress Bold', path: fontPaths.arteria },
        {
          name: 'Arteria Compress Demi',
          OT: 'Italian A',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.vuitton,
    },
    {
      name: 'Aceto',
      path: 'images/labels/Arteria_fili-shop-signs-aceto-vino.png',
      span: 1,
      fontList: [
        {
          name: 'Arteria Compress Regular',
          OT: 'Italian A',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.fili,
    },
    {
      name: 'Panafico',
      path: 'images/labels/Arteria_fili-shop-signs-panafico.png',
      span: 2,
      fontList: [
        {
          name: 'Arteria Compress Regular',
          OT: 'Italian A',
          path: fontPaths.arteria,
        },
        { name: 'Aiglon Bold', OT: 'Milano', path: fontPaths.aiglon },
        { name: 'Aiglon Extended Demi', path: fontPaths.aiglon },
      ],
      selected: true,
      ref: refs.fili,
    },
    {
      name: 'Guglielmina Grand Hotel',
      path: 'images/labels/Arteria_etiquettes_hotel-guglielmina.png',
      span: 1,
      fontList: [
        { name: 'Arteria Compress ExtraBold', path: fontPaths.arteria },
        {
          name: 'Arteria Compress Regular',
          OT: 'Italian A',
          path: fontPaths.arteria,
        },
        { name: 'Aiglon ExtraBold', path: fontPaths.aiglon },
      ],
      selected: true,
      ref: refs.vuitton,
    },
    {
      name: 'Grand Hotel des Palmes',
      path: 'images/labels/Arteria_etiquettes_hotel-palmes.png',
      span: 1,
      fontList: [
        { name: 'Arteria Compress Heavy', path: fontPaths.arteria },
        {
          name: 'Arteria Compress Regular',
          OT: 'Single-story a',
          path: fontPaths.arteria,
        },
        {
          name: 'Arteria Compress Light',
          OT: 'Italian a',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.vuitton,
    },
    {
      name: 'Laboratorio telefoni',
      path: 'images/labels/Arteria_fili-shop-signs-laboratorio.png',
      span: 1,
      fontList: [
        {
          name: 'Arteria Compress Regular',
          OT: 'Italian a',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.fili,
    },
    {
      name: 'Olio di Oliva',
      path: 'images/labels/Arteria_fili-shop-signs-olio-oliva.png',
      span: 1,
      fontList: [
        {
          name: 'Arteria Compress Demi',
          OT: 'Italian a',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.fili,
    },
    {
      name: 'Grand Hotel Patron',
      path: 'images/labels/Arteria_etiquettes_hotel-patron.png',
      span: 1,
      fontList: [
        { name: 'Aiglon ExtraBold', path: fontPaths.aiglon },
        { name: 'Arteria Compress ExtraBold', path: fontPaths.arteria },
        {
          name: 'Arteria Compress Bold',
          OT: 'Italian a, Single-story a',
          path: fontPaths.arteria,
        },
        {
          name: 'Arteria Compress Regular',
          OT: 'Closed C',
          path: fontPaths.arteria,
        },
      ],
      selected: true,
      ref: refs.vuitton,
    },
    {
      name: 'Hotel Princesse',
      path: 'images/labels/Arteria_etiquettes_hotel-princesse.png',
      span: 1,
      fontList: [
        { name: 'Arteria Compress ExtraBold', path: fontPaths.arteria },
        { name: 'Arteria Compress Demi', path: fontPaths.arteria },
        { name: 'Arteria Compress Regular', path: fontPaths.arteria },
      ],
      selected: true,
      ref: refs.vuitton,
    },
  ]

  let grid
  let msnry
  let label
  let elementList
  let el
  let top

  onMount(() => {
    msnry = new Masonry(grid, {
      itemSelector: '.label',
      columnWidth: '.label',
      percentPosition: true,
      transitionDuration: 0,
    })
    imagesLoaded(grid).on('progress', function () {
      msnry.layout()
    })

    if ($calledFromLabel) {
      label = labels.find((x) => x.name === $calledFromLabel)
      clicked = label.name
      elementList = [...grid.children]
      el = elementList.find((x) => x.getAttribute('name') === label.name)
      setTimeout(() => {
        top = el.style.top.slice(0, -2)
        requestAnimationFrame(() => {
          window.scrollTo(0, top)
        })
      }, 300)
      toggleLabels(label)
    }

    checkForMobile()
    return () => {
      msnry.destroy()
      removeActiveListener()
    }
  })

  function removeActiveListener() {
    if (mql && mqlListener) {
      mql.removeListener(mqlListener)
    }
  }

  let mql
  let mqlListener
  let matches
  function checkForMobile() {
    removeActiveListener()
    mql = window.matchMedia('(max-width: 834px)')
    mql.addListener(mqlListener)
    matches = mql.matches
  }

  let showInfo = false
  let labelInfo

  function selectItem(itm) {
    for (let i = 0; i < labels.length; i++) {
      labels[i].selected = itm === labels[i]
      grid.children[i].classList.toggle('faded')
    }
  }

  function getHeight() {
    height = sidebarContent.getBoundingClientRect().height
  }

  let labelsContainer
  let sidebarContent
  let height
  function toggleLabels(label) {
    labelInfo = label
    selectItem(label)
    showInfo = true
    if (matches) {
      setTimeout(() => {
        sidebarContent = sidebar.querySelector('.wrapper')
        getHeight()
        labelsContainer.style.paddingBottom = height + 'px'
      }, 200)
    }
  }

  let clicked
  function handle_click() {
    const label = labels.find(
      (x) => x.name === this.parentNode.getAttribute('name')
    )
    toggleLabels(label)
    if (clicked === label.name) {
      handle_click_out()
      clicked = ''
    } else {
      clicked = label.name
    }
  }

  function handle_click_out() {
    showInfo = false
    for (let i = 0; i < labels.length; i++) {
      labels[i].selected = true
      grid.children[i].classList.toggle('faded')
    }
    setTimeout(() => {
      labelsContainer.style.paddingBottom = ''
    }, 200)
  }

  let sidebarWidth
  let sidebar
  function windowResize(innerWidth) {
    if (sidebar) {
      sidebarWidth = sidebar.getBoundingClientRect().width
    }
  }

  let innerWidth
  $: {
    windowResize(innerWidth)
    checkForMobile()
  }
</script>

<svelte:window on:keydown={handle_keydown} bind:innerWidth />
<div
  class="labels-container content-wrapper cols4-wrapper"
  on:click={handle_click_out}
  out:fade
  bind:this={labelsContainer}>
  <div bind:this={grid} class="labels-grid">
    {#each labels as label}
      <div
        name={label.name}
        class={label.span === 2 ? 'label double' : 'label'}
        class:faded={label.selected === false}>
        <img
          src={label.path}
          alt="Italian Sign set in Arteria"
          on:click|stopPropagation={handle_click} />
      </div>
    {/each}
  </div>
  <div class="sidebar" bind:this={sidebar}>
    {#if showInfo}
      <LabelInfo {labelInfo} {sidebarWidth} />
    {/if}
  </div>
</div>

<style lang="scss">
  @import '../../responsive.scss';

  .labels-grid {
    grid-column: 1 / span 2;

    @include for-phone {
      grid-column: 1 / span 3;
    }
  }
  .sidebar {
    grid-column: 3;
  }
  .labels-container {
    padding: 1em 3em 3em 3em;
    margin: auto;

    @include for-phone {
      padding: 1em;
    }
  }
  .label {
    width: 33%;
    padding: 0.5em;
    opacity: 1;
    transition: opacity 0.2s;
    &:hover {
      cursor: pointer;
    }
  }
  .faded {
    opacity: 0.4;
  }
  .double {
    width: 66%;
  }
</style>
